import React, { useState, useEffect } from 'react';

const Timer = ({ hours = 0, minutes = 0, seconds = 0 , onComplete, ...props}) => {
    // Calculate total seconds from input
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    const [timeLeft, setTimeLeft] = useState(totalSeconds);

    useEffect(() => {
        if (timeLeft <= 0) {
            if (onComplete) {
                onComplete(); // Call the onComplete function
            }
            return;
        }

        const interval = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeLeft]); // disabled because I want to do that
    // (the other option would to wrap the onComplete function definition in the parent files in a useCallback,
    // but I don't want to do that every time I use a timer

    // Calculate the remaining time in hours, minutes, and seconds
    const formatTime = () => {
        // const hrs = Math.floor(timeLeft / 3600);
        const mins = Math.floor((timeLeft % 3600) / 60);
        const secs = timeLeft % 60;
        // ${hrs.toString().padStart(2, '0')}:
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    return (
            <p {...props}>{formatTime()}</p>
    );
};

export default Timer;
